import { render, staticRenderFns } from "./Employees5.vue?vue&type=template&id=e53e2e78&scoped=true"
import script from "./Employees5.vue?vue&type=script&lang=ts"
export * from "./Employees5.vue?vue&type=script&lang=ts"
import style0 from "./Employees5.vue?vue&type=style&index=0&id=e53e2e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53e2e78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
